interface TrialInformationWithDiseaseAreas {
  nctId: string;
  phase: string;
  sponsor: string;
  diseaseAreas: ReadonlyArray<string>;
  title: string;
}

export interface TrialInformationWithEligibilityCriteria {
  nctId: string;
  sponsor: string;
  title: string;
  inclusionCriteria: string;
  exclusionCriteria: string;
}

const emptyTrialInformationWithEligibilityCriteria = () => ({
  nctId: '',
  sponsor: '',
  title: '',
  inclusionCriteria: '',
  exclusionCriteria: '',
});

const emptyTrialInformationWithDiseaseAreas = () => ({
  nctId: '',
  phase: '',
  sponsor: '',
  diseaseAreas: [],
  title: '',
});

export declare namespace TrialInformationFetchService {
  interface TrialInformationFetchService {
    getTrialInformationForTrialExperience: (
      studyId: string | null,
    ) => Promise<TrialInformationWithDiseaseAreas>;
    getTrialInformationForExternalTrialCreation: (
      studyId: string | null,
    ) => Promise<TrialInformationWithEligibilityCriteria>;
  }
}

export const TrialInformationFetchService = {
  emptyTrialInformationWithDiseaseAreas,
  emptyTrialInformationWithEligibilityCriteria,
};
